import React from "react"

function IconVideoLockSlash({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="video-lock-slash"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-video-lock-slash"
      {...props}
    >
      <path
        d="M5.472 8.981a3.776 3.776 0 0 1 3.77 3.568l.005.207v1.927h.39c.4 0 .725.325.725.725v6.334c0 .4-.324.725-.725.725h-8.33a.725.725 0 0 1-.726-.725v-6.334c0-.4.325-.725.725-.725h.39v-1.927a3.776 3.776 0 0 1 3.776-3.775zm3.581 7.011H1.89v5.166h7.163v-5.166zm-3.563.525a1.345 1.345 0 0 1 .654 2.52v.557a.655.655 0 0 1-1.3.106l-.008-.106-.001-.558a1.345 1.345 0 0 1 .655-2.519zm9.776.938 1.268 1.189c-.15.076-.318.12-.498.12h-4.833v-1.31h4.063zm.77-11.782c.603 0 1.091.488 1.091 1.09V8.99l4.288-1.786a.764.764 0 0 1 1.058.705v8.618a.764.764 0 0 1-1.058.705l-2.307-.96-3.29-3.086V6.982h-6.62l-1.396-1.31h8.234zm5.127 3.054-3.928 1.637v3.708l3.928 1.636v-6.98zM5.473 10.29a2.467 2.467 0 0 0-2.462 2.297l-.006.17v1.926h4.933v-1.927a2.466 2.466 0 0 0-2.466-2.466zm-1.22 1.388v2.163h-.406v-1.085l.005-.145.017-.143c.05-.298.187-.57.383-.79zm-1.09-5.569 1.09 1.021v1.172c-.47.129-.91.33-1.308.59V6.764c0-.246.082-.473.219-.655z"
        fill={color}
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
      <path
        d="M2.795 3.37a.655.655 0 0 1 .832-.102l.093.073 17.455 16.363a.655.655 0 0 1-.802 1.028l-.093-.073L2.825 4.296a.655.655 0 0 1-.03-.925z"
        fill={color2 || color}
        fillRule="nonzero"
        style={{ height: height || fontSize }}
        originalclass="__danger"
      />
    </svg>
  )
}

export default IconVideoLockSlash
